<template>
  <div :class="[defaultClass, showAsLink ? linkClass : '']">
    <button @click="closeClicked" class="unstyled-btn d-flex items-center" :aria-label="displayText || 'Remove item'">
      <div class="pill-item__display-text" v-text="displayText" />

      <div class="pill-item__remove-icon" />
    </button>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';

const emit = defineEmits<{
  (event: 'remove', displayText: string, dataModel: any): void;
}>();

const props = defineProps({
  dataModel: {
    type: [String, Object],
    required: true,
  },
  displayTextField: {
    type: String,
    default: '',
  },
  showAsLink: {
    type: Boolean,
    default: false,
  },
});

const linkClass = ref('link');
const defaultClass = ref('pill-item__container');

const displayText = computed(() => {
  if (props.displayTextField && typeof props.dataModel === 'object') {
    return props.dataModel[props.displayTextField];
  }

  // calculate the field to return if no field specified
  if (props.dataModel && typeof props.dataModel === 'object') {
    // grab the first item in the object
    const keyList = Object.keys(props.dataModel);
    return props.dataModel[keyList[0]];
  }

  return props.dataModel;
});

function closeClicked(event: Event) {
  event.preventDefault();
  event.stopPropagation();
  emit('remove', displayText.value, props.dataModel);
}
</script>
<style lang="scss" scoped>
.pill-item__container {
  background-color: lightgray;
  border-radius: 15px;
  height: 34px;
  display: flex;
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;

  &.link {
    background: transparent;
    .pill-item__display-text {
      text-decoration: underline;
      color: $racq-blue;
    }

    & .pill-item__remove-icon {
      background-image: url(@/assets/img/pill-item-link-remove.svg);
    }
  }
}

.pill-item__remove-icon {
  margin-left: auto;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  background-image: url(@/assets/img/pill-item-remove.svg);
  background-repeat: no-repeat;
  background-position: center;
  width: 0.75rem;
  height: 0.75rem;
  cursor: pointer;
}

.pill-item__display-text {
  display: flex;
  color: $racq-cool-grey;
  align-items: center;
  margin-left: 1rem;
  margin-right: 5px;
  cursor: pointer;
  font-family: $arial-regular-font;
  font-size: 1rem;
  font-weight: normal;
}
</style>
